module.exports = __webpack_public_path__ + "static/media/checker.60b42426.jpg";